// module
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// local
import styles from './Icon.pcss';

export default class Icon extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    hidden: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.string,
  }
  static defaultProps = {
    onClick: () => {},
  }

  render() {
    const { className, type, hidden, color, onClick } = this.props;
    
    const classes = classnames(className, styles.icon, {
      [styles.hidden]: hidden,
    });
    
    return (
      <span className={ classes } style={{ color }} onClick={ onClick }>
        { type }
      </span>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Icon/index.jsx